var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRentedicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    focusable: "false",
    className: "chakra-icon css-1dlsnza",
    "aria-label": "house-rented",
    fill: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "nonzero",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M9 20V15C9 14.4477 9.44772 14 10 14H12 M18.5 16.45C18.4724 16.45 18.45 16.4724 18.45 16.5C18.45 16.5276 18.4724 16.55 18.5 16.55C18.5276 16.55 18.55 16.5276 18.55 16.5C18.55 16.4724 18.5276 16.45 18.5 16.45V16.45 M15.1976 17.615L13.2922 19.5243C13.1051 19.7118 13 19.9658 13 20.2306V21C13 21.5523 13.4477 22 14 22H14.7711C15.0367 22 15.2914 21.8944 15.479 21.7064L17.3814 19.8001 M3 10.5803L10.6984 3.9815C11.4474 3.3395 12.5526 3.3395 13.3016 3.9815L21 10.5803 M10 20H3 M15.6235 5.97182V3.75C15.6235 3.33579 15.9593 3 16.3735 3H18.9644C19.3787 3 19.7144 3.33579 19.7144 3.75V9.47839 M4.2854 9.47852V20.0001 M15.1985 17.6159C15.0715 17.2574 15.0045 16.8804 15 16.5001C15 15.0845 15.8527 13.8083 17.1606 13.2665C18.4685 12.7248 19.9739 13.0242 20.9749 14.0252C21.9759 15.0262 22.2753 16.5316 21.7336 17.8395C21.1918 19.1474 19.9156 20.0001 18.5 20.0001C18.119 19.9956 17.7413 19.9284 17.3821 19.8009"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRentedicon);
export default __webpack_public_path__ + "static/media/rentedicon.8b4716d78ddb92e662382afb951b7c31.svg";
export { ForwardRef as ReactComponent };